/** USER ROLES ENUM */

// Server values
const ADMIN = 'admin';
const SALES = 'salesperson';

// Map server values to user friendly labels
// @todo replace roleName and role.name using this mapping
const label: { [key: string]: string } = {};
label[ADMIN] = 'Admin';
label[SALES] = 'Sales';

const RolesEnum = { ADMIN, SALES, label };

export default RolesEnum;

// @warn these are only used for tracking purposes, DO NOT USE for other use cases
// as they are unreliable and bad practice
export const RolesIdMap = { 2: ADMIN, 3: SALES };
export const getRoleNameById = (id: number | string): string | undefined => {
  const [, name] = Object.entries(RolesIdMap).find(([nId]) => nId === id) || [];
  return name;
};

export enum RoleId {
  ADMIN = '2',
  SALES = '3',
}

export enum RoleStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}
